export default __webpack_public_path__ + "static/media/qrcode-dowload.d2aabb0a.png";